export const FETCH_APP_TOKEN_REQUEST = 'FETCH_APP_TOKEN_REQUEST'
export const FETCH_APP_TOKEN_SUCCESS = 'FETCH_APP_TOKEN_SUCCESS'
export const FETCH_APP_TOKEN_FAILURE = 'FETCH_APP_TOKEN_FAILURE'
export const FETCH_APP_TOKEN = 'FETCH_APP_TOKEN'
export const CLEAR_APP_TOKEN = 'CLEAR_APP_TOKEN'
export const LOG_AS_ADMIN = 'LOG_AS_ADMIN'
export const REFRESH_USER = 'REFRESH_USER'

export const CREATE_NEW_PLAN_REQUEST = 'CREATE_NEW_PLAN_REQUEST'
export const CREATE_NEW_PLAN_SUCCESS = 'CREATE_NEW_PLAN_SUCCESS'
export const CREATE_NEW_PLAN_FAILURE = 'CREATE_NEW_PLAN_FAILURE'
export const UPDATE_PLAN_REQUEST = 'UPDATE_PLAN_REQUEST'
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS'
export const UPDATE_PLAN_FAILURE = 'UPDATE_PLAN_FAILURE'
export const CLEAR_PLAN = 'CLEAR_PLAN'

export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST'
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS'
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE'
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS'

export const LOAD_PLAN_REQUEST = 'LOAD_PLAN_REQUEST'
export const LOAD_PLAN_SUCCESS = 'LOAD_PLAN_SUCCESS'
export const LOAD_PLAN_FAILURE = 'LOAD_PLAN_FAILURE'

export const DELETE_PLAN_REQUEST = 'DELETE_PLAN_REQUEST'
export const DELETE_PLAN_SUCCESS = 'DELETE_PLAN_SUCCESS'
export const DELETE_PLAN_FAILURE = 'DELETE_PLAN_FAILURE'

export const EXPORT_PLAN_TO_EXCEL_REQUEST = 'EXPORT_PLAN_TO_EXCEL_REQUEST'
export const EXPORT_PLAN_TO_EXCEL_SUCCESS = 'EXPORT_PLAN_TO_EXCEL_SUCCESS'
export const EXPORT_PLAN_TO_EXCEL_FAILURE = 'EXPORT_PLAN_TO_EXCEL_FAILURE'

export const PLAN_UPLOAD_STATUS = 'PLAN_UPLOAD_STATUS'

export const UNAUTHORIZED_MESSAGE = 'Error: Request failed with status code 401'

export const DASHBOARD_PATH = '/dashboard'
export const LOGIN_PATH = '/'
export const LOAD_PLAN_PATH = '/plan/:plan_id'
export const PASSWORD_RESET_PATH = '/password_reset'
export const PASSWORD_CHANGE_PATH = '/password_change/:token'
export const PLAN_ACTIVITIES_PATH = '/plan/:plan_id/activities'
export const ADMIN_TEMPLATE_PATH = '/admin/:template_id'
export const USERS_PATH = '/users'
export const LIBRARY_CONTROLS_PATH = '/control_library'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

export const SYSTEM_TITLE = 'InterWRACtive'

export const CREATE_CONTROL_REQUEST = 'CREATE_CONTROL_REQUEST'
export const CREATE_CONTROL_SUCCESS = 'CREATE_CONTROL_SUCCESS'
export const CREATE_CONTROL_FAILURE = 'CREATE_CONTROL_FAILURE'
export const UPDATE_CONTROL_REQUEST = 'UPDATE_CONTROL_REQUEST'
export const UPDATE_CONTROL_SUCCESS = 'UPDATE_CONTROL_SUCCESS'
export const UPDATE_CONTROL_FAILURE = 'UPDATE_CONTROL_FAILURE'
export const DELETE_CONTROL_REQUEST = 'DELETE_CONTROL_REQUEST'
export const DELETE_CONTROL_SUCCESS = 'DELETE_CONTROL_SUCCESS'
export const DELETE_CONTROL_FAILURE = 'DELETE_CONTROL_FAILURE'
export const GET_UNIQUE_CONTROL_REQUEST = 'GET_UNIQUE_CONTROL_REQUEST'
export const GET_UNIQUE_CONTROL_SUCCESS = 'GET_UNIQUE_CONTROL_SUCCESS'
export const GET_UNIQUE_CONTROL_FAILURE = 'GET_UNIQUE_CONTROL_FAILURE'

export const TOGGLE_RISK_REQUEST = 'TOGGLE_RISK_REQUEST'
export const TOGGLE_RISK_SUCCESS = 'TOGGLE_RISK_SUCCESS'
export const TOGGLE_RISK_FAILURE = 'TOGGLE_RISK_FAILURE'

export const UPDATE_RISK_REQUEST = 'UPDATE_RISK_REQUEST'
export const UPDATE_RISK_SUCCESS = 'UPDATE_RISK_SUCCESS'
export const UPDATE_RISK_FAILURE = 'UPDATE_RISK_FAILURE'

export const CREATE_RISK_REQUEST = 'CREATE_RISK_REQUEST'
export const CREATE_RISK_SUCCESS = 'CREATE_RISK_SUCCESS'
export const CREATE_RISK_FAILURE = 'CREATE_RISK_FAILURE'

export const DELETE_RISK_REQUEST = 'DELETE_RISK_REQUEST'
export const DELETE_RISK_SUCCESS = 'DELETE_RISK_SUCCESS'
export const DELETE_RISK_FAILURE = 'DELETE_RISK_FAILURE'

export const UPDATE_RISK_BY_LEVEL_REQUEST = 'UPDATE_RISK_BY_LEVEL_REQUEST'
export const UPDATE_RISK_BY_LEVEL_SUCCESS = 'UPDATE_RISK_BY_LEVEL_SUCCESS'
export const UPDATE_RISK_BY_LEVEL_FAILURE = 'UPDATE_RISK_BY_LEVEL_FAILURE'

export const DELETE_RISK_BY_LEVEL_REQUEST = 'DELETE_RISK_BY_LEVEL_REQUEST'
export const DELETE_RISK_BY_LEVEL_SUCCESS = 'DELETE_RISK_BY_LEVEL_SUCCESS'
export const DELETE_RISK_BY_LEVEL_FAILURE = 'DELETE_RISK_BY_LEVEL_FAILURE'

export const UPDATE_TAGS_REQUEST = 'UPDATE_TAGS_REQUEST'
export const UPDATE_TAGS_SUCCESS = 'UPDATE_TAGS_SUCCESS'
export const UPDATE_TAGS_FAILURE = 'UPDATE_TAGS_FAILURE'

export const GET_COMPARISONS_REQUEST = 'GET_COMPARISONS_REQUEST'
export const GET_COMPARISONS_SUCCESS = 'GET_COMPARISONS_SUCCESS'
export const GET_COMPARISONS_FAILURE = 'GET_COMPARISONS_FAILURE'

export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST'
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE'

export const CLEAR_RISK = 'CLEAR_RISK'
export const CLEAR_CONTROL = 'CLEAR_CONTROL'
export const CLEAR_TAGS = 'CLEAR_TAGS'

export const GET_TRANSLATIONS_REQUEST = 'GET_TRANSLATIONS_REQUEST'
export const GET_TRANSLATIONS_SUCCESS = 'GET_TRANSLATIONS_SUCCESS'
export const GET_TRANSLATIONS_FAILURE = 'GET_TRANSLATIONS_FAILURE'

export const GET_TREE_REQUEST = 'GET_TREE_REQUEST'
export const GET_TREE_SUCCESS = 'GET_TREE_SUCCESS'
export const GET_TREE_FAILURE = 'GET_TREE_FAILURE'

export const GET_PLAN_TAGS_REQUEST = 'GET_PLAN_TAGS_REQUEST'
export const GET_PLAN_TAGS_SUCCESS = 'GET_PLAN_TAGS_SUCCESS'
export const GET_PLAN_TAGS_FAILURE = 'GET_PLAN_TAGS_FAILURE'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST'
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS'
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE'

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE'

export const GET_USER_TAGS_REQUEST = 'GET_USER_TAGS_REQUEST'
export const GET_USER_TAGS_SUCCESS = 'GET_USER_TAGS_SUCCESS'
export const GET_USER_TAGS_FAILURE = 'GET_USER_TAGS_FAILURE'
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR'

export const GET_PLAN_PERMISSIONS_REQUEST = 'GET_PLAN_PERMISSIONS'
export const GET_PLAN_PERMISSIONS_SUCCESS = 'GET_PLAN_PERMISSIONS_SUCCESS'
export const GET_PLAN_PERMISSIONS_FAILURE = 'GET_PLAN_PERMISSIONS_FAILURE'

export const UPDATE_PLAN_PERMISSIONS_REQUEST = 'UPDATE_PLAN_PERMISSIONS_REQUEST'
export const UPDATE_PLAN_PERMISSIONS_SUCCESS = 'UPDATE_PLAN_PERMISSIONS_SUCCESS'
export const UPDATE_PLAN_PERMISSIONS_FAILURE = 'UPDATE_PLAN_PERMISSIONS_FAILURE'

export const GET_INSTANCE_CONFIG_REQUEST = 'GET_INSTANCE_CONFIG_REQUEST'
export const GET_INSTANCE_CONFIG_SUCCESS = 'GET_INSTANCE_CONFIG_SUCCESS'
export const GET_INSTANCE_CONFIG_FAILURE = 'GET_INSTANCE_CONFIG_FAILURE'

export const GET_USER_PLAN_PERMISSION_MATRIX_VALUES_REQUEST = 'GET_USER_PLAN_PERMISSION_MATRIX_VALUES_REQUEST'
export const GET_USER_PLAN_PERMISSION_MATRIX_VALUES_SUCCESS = 'GET_USER_PLAN_PERMISSION_MATRIX_VALUES_SUCCESS'
export const GET_USER_PLAN_PERMISSION_MATRIX_VALUES_FAILURE = 'GET_USER_PLAN_PERMISSION_MATRIX_VALUES_FAILURE'

export const EXPORT_PLANS_REQUEST = 'EXPORT_PLANS_REQUEST'
export const EXPORT_PLANS_SUCCESS = 'EXPORT_PLANS_SUCCESS'
export const EXPORT_PLANS_FAILURE = 'EXPORT_PLANS_FAILURE'

export const GET_LIBRARY_CONTROLS_REQUEST = 'GET_LIBRARY_CONTROLS_REQUEST'
export const GET_LIBRARY_CONTROLS_SUCCESS = 'GET_LIBRARY_CONTROLS_SUCCESS'
export const GET_LIBRARY_CONTROLS_FAILURE = 'GET_LIBRARY_CONTROLS_FAILURE'

export const CREATE_LIBRARY_CONTROL_REQUEST = 'CREATE_LIBRARY_CONTROL_REQUEST'
export const CREATE_LIBRARY_CONTROL_SUCCESS = 'CREATE_LIBRARY_CONTROL_SUCCESS'
export const CREATE_LIBRARY_CONTROL_FAILURE = 'CREATE_LIBRARY_CONTROL_FAILURE'

export const UPDATE_LIBRARY_CONTROL_REQUEST = 'UPDATE_LIBRARY_CONTROL_REQUEST'
export const UPDATE_LIBRARY_CONTROL_SUCCESS = 'UPDATE_LIBRARY_CONTROL_SUCCESS'
export const UPDATE_LIBRARY_CONTROL_FAILURE = 'UPDATE_LIBRARY_CONTROL_FAILURE'

export const ARCHIVE_LIBRARY_CONTROL_REQUEST = 'ARCHIVE_LIBRARY_CONTROL_REQUEST'
export const ARCHIVE_LIBRARY_CONTROL_SUCCESS = 'ARCHIVE_LIBRARY_CONTROL_SUCCESS'
export const ARCHIVE_LIBRARY_CONTROL_FAILURE = 'ARCHIVE_LIBRARY_CONTROL_FAILURE'

export const UNARCHIVE_LIBRARY_CONTROL_REQUEST = 'UNARCHIVE_LIBRARY_CONTROL_REQUEST'
export const UNARCHIVE_LIBRARY_CONTROL_SUCCESS = 'UNARCHIVE_LIBRARY_CONTROL_SUCCESS'
export const UNARCHIVE_LIBRARY_CONTROL_FAILURE = 'UNARCHIVE_LIBRARY_CONTROL_FAILURE'

export const GET_CONTROL_OWNERS_REQUEST = 'GET_CONTROL_OWNERS_REQUEST'
export const GET_CONTROL_OWNERS_SUCCESS = 'GET_CONTROL_OWNERS_SUCCESS'
export const GET_CONTROL_OWNERS_FAILURE = 'GET_CONTROL_OWNERS_FAILURE'

export const GET_CONTROL_TAGS_REQUEST = 'GET_CONTROL_TAGS_REQUEST'
export const GET_CONTROL_TAGS_SUCCESS = 'GET_CONTROL_TAGS_SUCCESS'
export const GET_CONTROL_TAGS_FAILURE = 'GET_CONTROL_TAGS_FAILURE'

export const SHOW_TRANSLATION_MODAL = "SHOW_TRANSLATION_MODAL";
export const HIDE_TRANSLATION_MODAL = "HIDE_TRANSLATION_MODAL";
export const PENDING_LIBRARY_CONTROL_TRANSLATION = 'PENDING_LIBRARY_CONTROL_TRANSLATION';
export const COMPLETED_LIBRARY_CONTROL_TRANSLATION = 'COMPLETED_LIBRARY_CONTROL_TRANSLATION';
export const FAILED_LIBRARY_CONTROL_TRANSLATION = 'FAILED_LIBRARY_CONTROL_TRANSLATION';
export const SAVE_RISK_TRANSLATION = "SAVE_RISK_TRANSLATION";
export const SNACKBAR_ADD_MESSAGE = 'SNACKBAR_ADD_MESSAGE'
export const SNACKBAR_REMOVE_MESSAGE = 'SNACKBAR_REMOVE_MESSAGE'

export const TAG_OPTIONS = [
  {
    key: 'Admin',
    value: 'Admin',
    text: 'Admin'
  },
  {
    key: 'Critical',
    value: 'Critical',
    text: 'Critical'
  },
  {
    key: 'Elim',
    value: 'Elim',
    text: 'Elim'
  },
  {
    key: 'Eng-ing',
    value: 'Eng-ing',
    text: 'Eng-ing'
  },
  {
    key: 'Sub',
    value: 'Sub',
    text: 'Sub'
  },
  {
    key: 'PPE-EPP',
    value: 'PPE-EPP',
    text: 'PPE-EPP'
  },
]

export function generateActionTypes(action) {
  return {
    request: `${action}_REQUEST`,
    success: `${action}_SUCCESS`,
    failure: `${action}_FAILURE`,
  }
}

export const GET_PLAN_CHANGE_LOGS = generateActionTypes('GET_PLAN_CHANGE_LOGS')
export const GET_LIBRARY_CONTROL_REVIEWS = generateActionTypes('GET_LIBRARY_CONTROL_REVIEWS')
export const LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED = generateActionTypes('LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED')
export const EXPORT_LIBRARY_CONTROLS_TO_EXCEL = generateActionTypes('EXPORT_LIBRARY_CONTROLS_TO_EXCEL');
export const CREATE_CONTROLS = generateActionTypes('CREATE_CONTROLS')
export const UPDATE_RISK_TAGS = generateActionTypes('UPDATE_RISK_TAGS');

export const CHANGE_LOG_FILTERS = [
  { key: "tagged_as_pue_log", text: "Tagged as PUE Logs", value: "tagged_as_pue_log" },
  { key: "new_unwanted_event_log", text: "New Unwanted Event Logs", value: "new_unwanted_event_log" },
]

// Tool Tip IDs
export const LOGIN_TOOL_TIP_ID = 'TPDGLIAAC';
export const RESET_PASSWORD_TOOL_TIP_ID = 'TPDGFPWIP';
export const RISK_PLANS_NORMAL_USER_TIP_ID = 'TPDGDBAAA';
export const RISK_PLANS_ADMIN_USER_TIP_ID = 'TPDGDBAFA';
export const USER_PERMISSIONS_TIP_ID = 'TPDGPSUUO';
export const EXPORT_PLAN_TIP_ID = 'TPDGESPMM';
export const RISK_TEMPLATES_NORMAL_USER_TIP_ID = 'TPDGRTNUU';
export const RISK_TEMPLATES_ADMIN_USER_TIP_ID = 'TPDGRTAUQ';
export const PLAN_SCOPE_TIP_ID = 'TPDGPSWVP';
export const PROJECT_CONTROL_REGISTER_TIP_ID = 'TPDGPCRVP';
export const REQUIRE_REVIEW_TIP_ID = 'TPDGRRCFF';
export const NEW_WORK_PHASE_OR_AMBIENT_EXPOSURE_TIP_ID = 'TPDGNWOAE';
export const CREATE_INSPECTION_TIP_ID = 'TPDGCITIP';
export const WORK_PHASE_OR_AMBIENT_EXPOSURE_COLUMN_TIP_ID = 'TPDGWPAEC';
export const ACTIVITY_COLUMN_TIP_ID = 'TPDGACTJK';
export const HAZARD_COLUMN_TIP_ID = 'TPDGHZRSV';
export const UNWANTED_EVENT_COLUMN_TIP_ID = 'TPDGUEHXC';
export const EXISTING_PREVENTATIVE_CONTROLS_COLUMN_TIP_ID = 'TPDGEPCOL';
export const EXISTING_RECOVERY_CONTROLS_COLUMN_TIP_ID = 'TPDGERCMN';
export const LIKELIHOOD_OF_UNWANTED_EVENT_A_COLUMN_TIP_ID = 'TPDGLHOUE';
export const CONSEQUENCE_COLUMN_TIP_ID = 'TPDGCNSIP';
export const CURRENT_CONSEQUENCE_RATING_COLUMN_TIP_ID = 'TPDGCCRUI';
export const RESIDUAL_RISK_RATING_COLUMN_TIP_ID = 'TPDGRCRRJ';
export const ADDITIONAL_PREVENTATIVE_CONTROLS_COLUMN_TIP_ID = 'TPDGAPCUQ';
export const ADDITIONAL_RECOVERY_CONTROLS_COLUMN_TIP_ID = 'TPDGARCWD';
export const LIKELIHOOD_OF_UNWANTED_EVENT_B_COLUMN_TIP_ID = 'TPDGLHOUQ';
export const FINAL_CONSEQUENCE_RATING_COLUMN_TIP_ID = 'TPDGFCRGJ';
export const FORECAST_RESIDUAL_RISK_RATING_COLUMN_TIP_ID = 'TPDGFRFRR';
export const ACTIONS_1_COLUMN_TIP_ID = 'TPDGACYHN';
export const INDIVIDUAL_ACCOUNTABLE_2_COLUMN_TIP_ID = 'TPDGIAFMS';
export const ADDITIONAL_CONTROL_EFFECTIVENESS_3_COLUMN_TIP_ID = 'TPDGHEACV';
export const PLANNED_ACTIONS_STATUS_4_COLUMN_TIP_ID = 'TPDGWSPAD';
export const KEY_CONTROLS_EFFECTIVENESS_5_COLUMN_TIP_ID = 'TPDGHEKCV';


// WEBPACK FOOTER //
// ./src/constants.js